import styled from 'styled-components'

export const Header = styled.header`
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.graysGray3};
  display: flex;
  height: 79px;
  padding: 0 32px;
  position: relative;

  .logo-cora {
    position: absolute;
  }

  @media screen and (max-width: 850px) {
    & {
      height: auto;
      padding: 24px;
    }

    &,
    & .logo-cora {
      position: initial;
    }
  }
`

export const Content = styled.div`
  margin: 0 auto;
  width: 500px;

  @media screen and (max-width: 850px) {
    & {
      margin: 0 24px;
      max-width: 500px;
    }
  }
`
